import { MapPin, Phone, MessageCircle } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { ContactForm } from "./ContactForm";
import { ADDRESS, PHONE, PHONE_TEL, waLink } from "@/lib/site";

const MAP_SRC = `https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`;

const InfoRow = ({ icon: Icon, label, children }) => (
  <div className="flex gap-4">
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold/10 text-[var(--gold)]"><Icon className="h-5 w-5" /></span>
    <div>
      <p className="text-xs uppercase tracking-wider text-slate-400">{label}</p>
      <div className="mt-1 text-sm text-white">{children}</div>
    </div>
  </div>
);

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead eyebrow="Contact Us" title={<>Let's Build Something <span className="text-gold-grad italic">Amazing</span> Together!</>} intro="Ready to take your business online? Contact Pratap Group today for an affordable, professional website." />
      <div className="mt-16 grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
        <Reveal className="flex flex-col gap-6">
          <div className="rounded-3xl border border-white/[0.08] bg-navy/60 p-8">
            <p className="font-display text-2xl font-semibold text-white">Pratap Group</p>
            <div className="mt-8 space-y-6">
              <InfoRow icon={MapPin} label="Address"><span data-testid="contact-address">{ADDRESS}</span></InfoRow>
              <InfoRow icon={Phone} label="Mobile"><a href={PHONE_TEL} data-testid="contact-phone-link" className="hover:text-[var(--gold)]">{PHONE}</a></InfoRow>
              <InfoRow icon={MessageCircle} label="WhatsApp"><a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-link" className="hover:text-[var(--gold)]">{PHONE}</a></InfoRow>
            </div>
            <div className="mt-8 grid gap-3 sm:grid-cols-2">
              <a href={PHONE_TEL} data-testid="contact-call-button" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:border-[var(--gold)] hover:text-[var(--gold)]"><Phone className="h-4 w-4" /> Call Now</a>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-button" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] py-3 text-sm font-semibold text-black transition-transform duration-300 hover:-translate-y-0.5"><MessageCircle className="h-4 w-4" /> WhatsApp Chat</a>
            </div>
          </div>
          <div className="relative min-h-[280px] flex-1 overflow-hidden rounded-3xl border border-white/[0.08]">
            <iframe title="Pratap Group location on Google Maps" data-testid="contact-map" src={MAP_SRC} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="absolute inset-0 h-full w-full [filter:invert(.92)_hue-rotate(185deg)_saturate(.7)]" />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="glass h-full rounded-3xl p-6 sm:p-10">
            <p className="font-display mb-8 text-xl font-semibold text-white">Request a Free Quote</p>
            <ContactForm />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
